import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton } from './AppStoreButton';
export function CtaSection() {
  return <section className="bg-black py-24 px-6" data-id="element-17">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-19">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-10 leading-tight" data-id="element-20">
            Start creating music today
          </h2>

          <div className="flex justify-center mb-14" data-id="element-21">
            <AppStoreButton data-id="element-22" />
          </div>
        </motion.div>

        <div className="flex items-center justify-center gap-4 mb-3" data-id="element-23">
          <a href="https://go.pixo.co/croon-terms" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white/80 text-sm font-medium transition-colors" data-id="element-24">
            Privacy
          </a>
          <span className="text-white/20" data-id="element-25">·</span>
          <a href="https://go.pixo.co/croon-privacy" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white/80 text-sm font-medium transition-colors" data-id="element-26">
            Terms
          </a>
          <span className="text-white/20" data-id="element-27">·</span>
          <a href="mailto:support@pixo.co" className="text-white/50 hover:text-white/80 text-sm font-medium transition-colors" data-id="element-28">
            Contact Support
          </a>
        </div>
        <div className="text-white/30 text-sm font-medium" data-id="element-29">
          © {new Date().getFullYear()} Croon. All rights reserved.
        </div>
      </div>
    </section>;
}